import styled from 'styled-components'

export const Container = styled.div`
  max-width: 640px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #F7F7F7;
  border-radius: 15px;
  padding: 10px;
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`

export const StepRow = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin: 10px 0px 5px;
`

export const StepContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`

export const StepIndicator = styled.div`
  width: 32px;
  height: 32px;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background-color: ${({ active, isCompleted }) => (
    active ? '#FFC100' : isCompleted ? '#44CF6C' : '#DDDDDD'
  )};
`

export const StepLineContainer = styled.div`
  position: absolute;
  top: 15px;
  left: 80px;
  right: 80px;
  height: 2px;
  z-index: 0;
`

export const StepLineBackground = styled.span`
  position: absolute;
  width: 100%;
  height: 2px;
  background-color: #DDDDDD;
`

export const StepLineProgress = styled.span`
  position: absolute;
  height: 2px;
  background-color: #44CF6C;
  width: ${({ progress }) => progress}%;
  transition: width 0.3s ease-in-out;
`

export const StepLabel = styled.p`
  color: #777777;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  margin: 0px;
`

export const StepNumber = styled.p`
  color: #000000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 1px;
`

export const FormField = styled(Container)`
  flex: ${props => props.stretch ? props.stretch : 1};
  justify-content: flex-end;
  align-items: center;
  padding: 0px;
  margin: 0px;
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 10px;
  margin-bottom: 10px;
  flex-direction: row;
  align-items: flex-end;
`

export const ProductGrid = styled.div`
  width: 100%;
  display: grid;
  position: relative;
  align-items: flex-end;
  margin-bottom: 3px;
  padding-top: 7px;
  border-top: 1px solid #F0F0F0;
  grid-template-columns: 260px 140px auto;
  gap: 10px;
  cursor: auto;
`

export const InfoText = styled.p`
  color: #000000;
  font-size: 14px;
  text-align: center;
  margin-bottom: 0px;
`

export const Title = styled(InfoText)`
  font-size: 16px;
  font-weight: bold;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
`

export const Label = styled.label`
  text-align: center;
  color: #000000;
  line-height: 15px;
  margin-bottom: 7px;

  &:hover {
    cursor: pointer;
  }
`

export const HighlightText = styled.span`
  color: #FFC100;
  font-size: 14px;
  font-weight: bold;
`

export const WarningText = styled.p`
  margin: 0px;
  text-align: center;
  font-size: 14px;
  font-weight: 200;
  color: #FF3939;
`

export const ErrorContainer = styled.div`
  padding: 8px;
  margin-bottom: 20px;
  width: 100%;
  border-radius: 15px;
  text-align: center;
  background-color: #FF3939;

  p {
    color: #FFFFFF;
    margin: 0px;
  }
`
